//Guest
export const apiGetAllTopicGuest = "Guest/GetAllTopic"
export const apiGetByRegionId = "Guest/GetByRegionId"
export const apiGetAllCourse = "Guest/GetAllCourse"
export const apiGetAllTeacher = "/Guest/GetAllTeacher"
export const apiGetAllCourseHome = "Guest/GetAllCourseHome"
export const apiGetAllTopicByCourse = "Guest/GetAllTopicByCourse"
export const apiGetDetailCourse = "Guest/GetDetailCourse"
export const apiGetListBannerFooterEvent = "Guest/GetListBannerFooterEvent"
export const apiGetListEvent = "Guest/GetListEventGuest"
export const apiGetTeacherHome = "Guest/GetTearcher"
export const apiGetPostHome = "Guest/GetPostHome"
export const apiGetPostList = "Guest/GetList"
export const apiGetPostDetail = "Guest/GetDetail"
export const apiUpdateLessonLearned = "Guest/UpdateLessonLearned"
export const apiGetCategoryPost = "Guest/GetCategoryPost"
export const apiGetDetailByG = "Guest/GetPostDetail"
export const apiGetListStaticNavbar = "Guest/GetListStaticNavbar"
export const apiGetListPostByCategoryPostID =
  "Guest/GetListPostByCategoryPostID"
export const apiGetListPostRelate = "Guest/GetListPostRelate"
export const apiGetAllListPost = "Guest/GetAllListPost"
